import { useEffect, useState } from 'react';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../../firebase-config';
import {
  CLIENT_LOGIN_PATH,
  getDefaultClientPath
} from '../../config/clientAccess';
import './ClientLogin.css';

const ClientLogin = ({ user = null, accessDenied = false }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const destinationPath = getDefaultClientPath(user);

  useEffect(() => {
    if (user && destinationPath && !accessDenied) {
      window.location.replace(destinationPath);
    }
  }, [accessDenied, destinationPath, user]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const credential = await signInWithEmailAndPassword(auth, email, password);
      const clientPath = getDefaultClientPath(credential.user);

      if (clientPath) {
        window.location.replace(clientPath);
      } else {
        setError('Tu cuenta no tiene acceso a ningún portal de clientes.');
      }
    } catch (loginError) {
      setError('Correo o contraseña incorrectos.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    window.location.replace(CLIENT_LOGIN_PATH);
  };

  if (user && (accessDenied || !destinationPath)) {
    return (
      <main className="client-login-page">
        <section className="client-login-card client-access-denied" aria-labelledby="access-denied-title">
          <span className="client-login-eyebrow">Portal de clientes DataDos</span>
          <div className="client-access-icon" aria-hidden="true">!</div>
          <h1 id="access-denied-title">Acceso denegado</h1>
          <p>La cuenta <strong>{user.email}</strong> no está autorizada para acceder a este portal.</p>
          <button className="client-login-button" type="button" onClick={handleLogout}>
            Cerrar sesión
          </button>
        </section>
      </main>
    );
  }

  if (user && destinationPath) {
    return (
      <main className="client-login-page" aria-live="polite">
        <div className="client-auth-loader" role="status">
          <span className="client-auth-spinner" aria-hidden="true" />
          <p>Abriendo tu portal…</p>
        </div>
      </main>
    );
  }

  return (
    <main className="client-login-page">
      <section className="client-login-card" aria-labelledby="client-login-title">
        <span className="client-login-eyebrow">DataDos</span>
        <h1 id="client-login-title">Portal de clientes</h1>
        <p className="client-login-intro">
          Accede con las credenciales asociadas a tu cuenta.
        </p>

        <form className="client-login-form" onSubmit={handleLogin}>
          <label htmlFor="client-email">Correo electrónico</label>
          <input
            id="client-email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />

          <label htmlFor="client-password">Contraseña</label>
          <input
            id="client-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />

          {error && <p className="client-login-error" role="alert">{error}</p>}

          <button className="client-login-button" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Accediendo…' : 'Entrar'}
          </button>
        </form>
      </section>
    </main>
  );
};

export default ClientLogin;
